<app-header-nav></app-header-nav>

<div class="container mx-auto p-6">
  <div class="flex items-center mb-6">
    <button mat-icon-button (click)="onBack()"><mat-icon>arrow_back</mat-icon></button>
    <h1 class="text-2xl font-bold ml-2">Admin Dashboard — Bar Approvals</h1>
  </div>

  <div class="grid grid-cols-3 gap-4 mb-6">
    <mat-card class="text-center p-4">
      <div class="text-3xl font-bold text-yellow-600">{{ pendingBars.length }}</div>
      <div class="text-sm text-gray-500">Pending Approval</div>
    </mat-card>
    <mat-card class="text-center p-4">
      <div class="text-3xl font-bold text-green-600">{{ approvedBars.length }}</div>
      <div class="text-sm text-gray-500">Approved</div>
    </mat-card>
    <mat-card class="text-center p-4">
      <div class="text-3xl font-bold text-red-600">{{ rejectedBars.length }}</div>
      <div class="text-sm text-gray-500">Rejected</div>
    </mat-card>
  </div>

  <mat-tab-group (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Pending ({{ pendingBars.length }})">
      <div class="p-4">
        <mat-table [dataSource]="pendingDataSource">
          <ng-container matColumnDef="barName">
            <mat-header-cell *matHeaderCellDef>Bar Name</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.barName }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="ownerName">
            <mat-header-cell *matHeaderCellDef>Owner</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.ownerFirstName }} {{ bar.ownerLastName }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="city">
            <mat-header-cell *matHeaderCellDef>City</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.city }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="licenseNumber">
            <mat-header-cell *matHeaderCellDef>License</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.licenseNumber }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef>Submitted</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.createdAt | date:'mediumDate' }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
            <mat-cell *matCellDef="let bar">
              <button mat-button color="primary" (click)="viewBarDetails(bar.id)">View</button>
              <button mat-button color="accent" (click)="approveBar(bar.id)">Approve</button>
              <button mat-button color="warn" (click)="openRejectDialog(bar)">Reject</button>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <p *ngIf="pendingBars.length === 0" class="text-center text-gray-500 py-8">No pending bars</p>
      </div>
    </mat-tab>

    <mat-tab label="Approved ({{ approvedBars.length }})">
      <div class="p-4">
        <mat-table [dataSource]="approvedDataSource">
          <ng-container matColumnDef="barName">
            <mat-header-cell *matHeaderCellDef>Bar Name</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.barName }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="ownerName">
            <mat-header-cell *matHeaderCellDef>Owner</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.ownerFirstName }} {{ bar.ownerLastName }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="city">
            <mat-header-cell *matHeaderCellDef>City</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.city }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="licenseNumber">
            <mat-header-cell *matHeaderCellDef>License</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.licenseNumber }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef>Approved</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.updatedAt | date:'mediumDate' }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
            <mat-cell *matCellDef="let bar">
              <button mat-button color="primary" (click)="viewBarDetails(bar.id)">View</button>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
      </div>
    </mat-tab>

    <mat-tab label="Rejected ({{ rejectedBars.length }})">
      <div class="p-4">
        <mat-table [dataSource]="rejectedDataSource">
          <ng-container matColumnDef="barName">
            <mat-header-cell *matHeaderCellDef>Bar Name</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.barName }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="ownerName">
            <mat-header-cell *matHeaderCellDef>Owner</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.ownerFirstName }} {{ bar.ownerLastName }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="city">
            <mat-header-cell *matHeaderCellDef>City</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.city }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="licenseNumber">
            <mat-header-cell *matHeaderCellDef>License</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.licenseNumber }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef>Rejected</mat-header-cell>
            <mat-cell *matCellDef="let bar">{{ bar.updatedAt | date:'mediumDate' }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
            <mat-cell *matCellDef="let bar">
              <button mat-button color="primary" (click)="viewBarDetails(bar.id)">View</button>
              <button mat-button color="accent" (click)="approveBar(bar.id)">Re-approve</button>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
      </div>
    </mat-tab>
  </mat-tab-group>

  <!-- Bar Detail Panel -->
  <mat-card *ngIf="selectedBar" class="mt-6 p-4">
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-xl font-bold">{{ selectedBar.barName }}</h2>
      <button mat-icon-button (click)="selectedBar = null"><mat-icon>close</mat-icon></button>
    </div>
    <div class="grid grid-cols-2 gap-4">
      <div><strong>Owner:</strong> {{ selectedBar.ownerFirstName }} {{ selectedBar.ownerLastName }}</div>
      <div><strong>Email:</strong> {{ selectedBar.ownerEmail }}</div>
      <div><strong>Phone:</strong> {{ selectedBar.phone || 'N/A' }}</div>
      <div><strong>License:</strong> {{ selectedBar.licenseNumber }}</div>
      <div><strong>Address:</strong> {{ selectedBar.addressLine1 }}, {{ selectedBar.city }}, {{ selectedBar.country }}</div>
      <div><strong>Description:</strong> {{ selectedBar.description || 'N/A' }}</div>
    </div>
    <div class="flex gap-2 mt-4" *ngIf="selectedBar.status === 'PENDING'">
      <button mat-raised-button color="primary" (click)="approveBar(selectedBar.id)">Approve</button>
      <button mat-raised-button color="warn" (click)="openRejectDialog(selectedBar)">Reject</button>
    </div>
  </mat-card>
</div>

<!-- Reject Dialog -->
<div *ngIf="showRejectDialog" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <mat-card class="p-6 w-96">
    <h3 class="text-lg font-bold mb-4">Reject Bar Registration</h3>
    <mat-form-field class="w-full">
      <mat-label>Rejection Reason</mat-label>
      <textarea matInput [(ngModel)]="rejectReason" rows="4" placeholder="Provide a reason..."></textarea>
    </mat-form-field>
    <div class="flex justify-end gap-2 mt-4">
      <button mat-button (click)="closeRejectDialog()">Cancel</button>
      <button mat-raised-button color="warn" (click)="confirmReject()">Reject</button>
    </div>
  </mat-card>
</div>

<app-footer></app-footer>
